var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterZ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.38,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.17L73.84 33v-1.16L0 33.1V0h132v39.71L58.77 47v1l73.61-1.26V80H0z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMzIuMzgiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCAxMzIuMzggODAiPgogIDxwYXRoIGQ9Ik0wLDQwLjE3LDczLjg0LDMzVjMxLjg0TDAsMzMuMVYwSDEzMlYzOS43MUw1OC43Nyw0N3YxbDczLjYxLTEuMjZWODBIMFoiIGZpbGw9IiNlOGZmYTIiLz4KPC9zdmc+Cg==";
export { SvgLetterZ as ReactComponent };